/**
 * Labstep
 *
 * @module components/Device/Action/UpdateTemplate
 * @desc Update device template
 */

import EntityActionUpdateTemplate from 'labstep-web/components/Entity/Action/UpdateTemplate';
import type React from 'react';
import type { DeviceActionUpdateTemplateProps } from './types';

export const DeviceActionUpdateTemplate: React.FC<
  DeviceActionUpdateTemplateProps
> = ({ device, actionType }) => (
  <EntityActionUpdateTemplate
    entity={device}
    actionType={actionType}
  />
);
